import React, { memo } from '../../../lib/teact/teact';
import Icon from '../icons/Icon';
import styles from './LarpersLandingFeatures.module.scss';
import tokenPillStyles from '../crypto/TokenPill.module.scss';
import pillStyles from '../DraggableTokenSellPill.module.scss';
import landingStyles from '../LarpersLanding.module.scss';
import buildClassName from '../../../util/buildClassName';

export const MockupTokenPill = memo(() => {
  return (
    <span className={tokenPillStyles.pillWrapper}>
      <span className={tokenPillStyles.pill} style={'cursor: default'}>
        <img className={tokenPillStyles.icon} src="pill-logo.png" alt="logo" style={'object-fit: cover;'} />
        <span className={tokenPillStyles.ticker}>Pepe 45k</span>
        <span className={buildClassName(tokenPillStyles.change, tokenPillStyles.positive)} style={'opacity: 1'}>
          +456.2%
        </span>
      </span>
    </span>
  );
});

export function AuditMockupCard() {
  return (
    <div className={styles.rightAlignedCard}>
      <div className={styles.safetyGrid}>
        <div className={styles.safetyItem}>
          <span className={styles.safetyLabel}>Top 10 H.</span>
          <span className={styles.safetyValue}>22.4%</span>
        </div>
        <div className={styles.safetyItem}>
          <span className={styles.safetyLabel}>Dev H.</span>
          <span className={styles.safetyValue}>0%</span>
        </div>
        <div className={styles.safetyItem}>
          <span className={styles.safetyLabel}>Snipers H.</span>
          <span className={styles.safetyValue}>14</span>
        </div>
        <div className={styles.safetyItem}>
          <span className={styles.safetyLabel}>Insiders</span>
          <span className={styles.safetyValue}>4.1%</span>
        </div>
        <div className={styles.safetyItem}>
          <span className={styles.safetyLabel}>Bundlers</span>
          <span className={styles.safetyValue}>8.5%</span>
        </div>
        <div className={styles.safetyItem}>
          <span className={styles.safetyLabel}>LP Burned</span>
          <span className={styles.safetyValue}>100%</span>
        </div>
        <div className={styles.safetyItem}>
          <span className={styles.safetyLabel}>Holders</span>
          <span className={styles.safetyValue}>4,219</span>
        </div>
        <div className={styles.safetyItem}>
          <span className={styles.safetyLabel}>Pro Traders</span>
          <span className={styles.safetyValue}>182</span>
        </div>
      </div>

      <div className={styles.auditRow}>
        <div className={buildClassName(styles.auditBadge, styles.badgeSuccess)}>
          <span>Dex Paid</span>
        </div>
        <div className={buildClassName(styles.auditBadge, styles.badgeSuccess)}>
          <span>Mint Renounced</span>
        </div>
        <div className={buildClassName(styles.auditBadge, styles.badgeSuccess)}>
          <span>Freeze Revoked</span>
        </div>
        <div className={styles.auditBadge}>
          <span>Tax: 0% / 0%</span>
        </div>
        <div className={buildClassName(styles.auditBadge, styles.badgeHighlight)}>
          <span>24 Smart</span>
        </div>
      </div>
    </div>
  );
}

export const AnalyticsMockupCard = memo(() => {
  return (
    <div className={styles.analyticsMockupCard}>
      {/* Historical Analytics Header */}
      <div className={styles.devThreatHeader}>
        <span className={styles.devThreatTitle}>First Larper</span>
        <span className={styles.devThreatBadge}>Live PnL</span>
      </div>
      
      {/* Linear Analytics Body */}
      <div className={styles.linearAnalyticsContainer}>
        <div className={styles.linearChipRow}>
          <div className={styles.linearChip}>
            [
            <span className={buildClassName(styles.chipValue, styles.clickableThreatValue)}>
              satoshi @ $13.7K ↗
            </span>
            ]
          </div>
          <div className={styles.linearChip}>
            [
            <span className={styles.chipLabel}>Up since call:</span>
            <span className={buildClassName(styles.devStatusTag, styles.statusActive)} style={'margin-left: 0.125rem;'}>
              +328%
            </span>
            ]
          </div>
        </div>
        <div className={styles.linearChipRow}>
          <div className={styles.linearChip}>
            [
            <span className={styles.chipLabel}>Since Call ATH:</span>
            <span className={styles.chipValue} style={'margin-left: 0.125rem;'}>$65.2K</span>
            <span className={buildClassName(styles.devStatusTag, styles.statusTargetHit)} style={'margin-left: 0.25rem;'}>
              +475%
            </span>
            ]
          </div>
          <div className={styles.linearChip}>
            [
            <span className={styles.chipLabel}>Vol:</span>
            <span className={styles.chipValue} style={'margin-left: 0.125rem;'}>
              $1.2M
            </span>
            ]
          </div>
        </div>
      </div>

      <div className={styles.mockupDivider} />

      {/* Threat Assessment Header */}
      <div className={styles.devThreatHeader}>
        <span className={styles.devThreatTitle}>Dev Larp Capability</span>
        <span className={styles.devThreatBadge}>
          4 coins analyzed
        </span>
      </div>
      
      {/* Threat Assessment Body */}
      <div className={styles.devThreatBody}>
        <div className={styles.devThreatRow}>
          <span className={styles.devThreatLabel}>Avg Peak</span>
          <span className={styles.devThreatValue}>
            $45K ➔ Now $13.7K
          </span>
          <span className={buildClassName(styles.devStatusTag, styles.statusNeutral)}>
            Under Peak
          </span>
        </div>
        <div className={styles.devThreatRow}>
          <span className={styles.devThreatLabel}>Avg Peak in</span>
          <span className={styles.devThreatValue}>
            1h 20m ➔ Now 45m
          </span>
          <span className={buildClassName(styles.devStatusTag, styles.statusActive)}>
            Safe
          </span>
        </div>
      </div>
    </div>
  );
});

export const SupportedChainsGlossy = memo(() => {
  return (
    <button className={styles.glossyButton}>
      <div className={styles.glossyOuterReflection} />
      <div className={styles.glossyInnerContainer}>
        <div className={styles.glossyInnerBg} />
        <div className={styles.glossyInnerPill}>
          <div className={styles.glossyInnerReflection} />
          <div className={styles.glossyContent}>
            <span>Solana</span>
            <div className={styles.glossyDivider} />
            <span>Robinhood</span>
          </div>
        </div>
      </div>
    </button>
  );
});

export const DraggablePillMockup = memo(() => {
  return (
    <div className={buildClassName(pillStyles.container, styles.pillMockupWrapper)}>
      <div className={pillStyles.capsule}>
        <div className={pillStyles.avatarWrap}>
          <div className={pillStyles.avatarMorph}>
            <img src="pill-logo.png" alt="pill" className={pillStyles.topImage} draggable={false} />
          </div>
        </div>
        <div className={pillStyles.hardwareThumb}>
          <Icon name="up" className={pillStyles.hardwareThumbIcon} />
        </div>
      </div>
    </div>
  );
});

export const AdminBadgeMockup = memo(() => {
  return (
    <div className={landingStyles.leftAlignedBadgeCard}>
      <img src="pill-logo.png" alt="logo" className={landingStyles.badgeAvatar} />
      <div className={landingStyles.badgeInfo}>
        <div className={landingStyles.badgeNameRow}>
          <span className={landingStyles.badgeName}>Project Team</span>
          <span className={landingStyles.adminBadgeLabel}>admin</span>
        </div>
      </div>
      <Icon name="more" className={landingStyles.badgeMoreIcon} />
    </div>
  );
});

export const BotBadgeMockup = memo(() => {
  return (
    <div className={landingStyles.rightAlignedBadgeCard}>
      <img src="pill-logo.png" alt="logo" className={landingStyles.badgeAvatar} />
      <div className={landingStyles.badgeInfo}>
        <div className={landingStyles.badgeNameRow}>
          <span className={landingStyles.badgeName}>Ugly Bot Data</span>
          <span className={landingStyles.botBadgeLabel}>bot</span>
        </div>
      </div>
      <Icon name="more" className={landingStyles.badgeMoreIcon} />
    </div>
  );
});


